import { Chip, Paper, Stack, Typography } from '@mui/material';

export interface FlowBotVariableOption {
    name: string;
    value: string;
}

interface FlowBotVariablesPanelProps {
    variables: FlowBotVariableOption[];
    onInsert: (value: string) => void;
}

const FlowBotVariablesPanel = ({ variables, onInsert }: FlowBotVariablesPanelProps) => {
    if (!variables.length) return null;

    return (
        <Paper
            variant="outlined"
            sx={{
                mt: 1,
                p: 1.5,
                bgcolor: 'action.hover',
            }}
        >
            <Typography variant="caption" fontWeight={600} sx={{ display: 'block', mb: 0.75 }}>
                Variáveis disponíveis — clique para inserir
            </Typography>
            <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
                {variables.map((variable) => (
                    <Chip
                        key={variable.value}
                        label={variable.name}
                        title={variable.value}
                        variant="outlined"
                        clickable
                        size="small"
                        onClick={() => onInsert(variable.value)}
                        sx={{
                            mb: 0.25,
                            fontSize: '0.7rem',
                            bgcolor: 'background.paper',
                        }}
                    />
                ))}
            </Stack>
        </Paper>
    );
};

export default FlowBotVariablesPanel;
